export const getSubjectName = (subject: string) => {
  if (subject === "Reading") {
    return "ELA";
  }
  return subject;
};
